import { useState, useEffect } from 'react';
import UserStore from 'base/user/user-store';
import cadenceGqlCall from '../utils/cadence-gql-call';
import { CADENCE_LIST_QUERY } from '../utils/cadence-queries';

/**
 * Fetch all cadence templates (blueprints).
 * Uses the unified cadenceList resolver with isTemplate filter — same resolver as useCadences.
 * Returns { templates, loading, error, refetch }.
 */
const useTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchKey, setFetchKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    cadenceGqlCall(CADENCE_LIST_QUERY, { filter: { isTemplate: true } })
      .then((data) => {
        if (cancelled) return;
        const currentUserId = String(UserStore.getUser()?.id ?? '');
        const nodes = (data.cadenceList?.edges || [])
          .map((e) => e?.node)
          .filter((n) => {
            if (!n?.id) return false;
            // Show only items the backend explicitly granted access to, or items you own.
            // canView: null means the backend didn't compute it — treat as no access.
            return n.canView === true || (currentUserId && String(n.ownerUserId) === currentUserId);
          });
        setTemplates(nodes.map((t) => ({ ...t, cadenceType: t.cadenceType?.toLowerCase() || t.cadenceType })));
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to fetch templates');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [fetchKey]);

  const refetch = () => setFetchKey((k) => k + 1);

  return { templates, loading, error, refetch };
};

export default useTemplates;
